
import { FileCategory } from "../types";

interface FilePreviewProps {
  file: File | null;
  category: string;
  title: string;
  fileCategories: FileCategory[];
}

export function FilePreview({ file, category, title, fileCategories }: FilePreviewProps) {
  if (!file) return null;
  
  const getCategoryLabel = (value: string) => {
    const categoryFound = fileCategories.find(c => c.value === value);
    return categoryFound ? categoryFound.label : 'Μη επιλεγμένη';
  };
  
  return (
    <div className="p-3 bg-muted rounded-md">
      <p className="text-sm font-medium">Επιλεγμένο Αρχείο:</p>
      <p className="text-sm">{file.name}</p>
      <p className="text-xs text-muted-foreground">
        {(file.size / (1024 * 1024)).toFixed(2)} MB
      </p>
      <p className="text-xs text-muted-foreground">
        Κατηγορία: {getCategoryLabel(category)}
      </p>
      {title && (
        <p className="text-xs text-muted-foreground">
          Τίτλος: {title}
        </p>
      )}
    </div>
  );
}
